/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/12/2020
 */
export const TimeSource = Object.freeze({
	SCHEDULER: "SCHEDULER",
	TIME_SLOTS: "TIME_SLOTS",
})
